<div class="table" [attr.role]="isTable ? 'table' : null">
    <ridango-table-header *ngIf="header.length>0" [elements]="header"></ridango-table-header>
    <ng-content></ng-content> 
</div>

<!--<div class="table" class="hide-desktop show-mobile">
    <ridango-table-header *ngIf="header.length>0" [elements]="header"></ridango-table-header>
    <ng-content></ng-content> 
</div>-->
